
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1wkd9_97",
  "button": "awsui_button_vjswe_1wkd9_101",
  "variant-normal": "awsui_variant-normal_vjswe_1wkd9_126",
  "is-activated": "awsui_is-activated_vjswe_1wkd9_139",
  "variant-icon": "awsui_variant-icon_vjswe_1wkd9_166",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1wkd9_166",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1wkd9_166",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1wkd9_184",
  "disabled": "awsui_disabled_vjswe_1wkd9_202",
  "variant-primary": "awsui_variant-primary_vjswe_1wkd9_210",
  "variant-link": "awsui_variant-link_vjswe_1wkd9_294",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1wkd9_546",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1wkd9_800",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1wkd9_887",
  "button-no-text": "awsui_button-no-text_vjswe_1wkd9_971",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1wkd9_975",
  "full-width": "awsui_full-width_vjswe_1wkd9_978",
  "icon-left": "awsui_icon-left_vjswe_1wkd9_995",
  "icon-right": "awsui_icon-right_vjswe_1wkd9_1000",
  "icon": "awsui_icon_vjswe_1wkd9_995"
};
  